export default "__VITE_ASSET__DmQ7JQ26__"